import React, { Fragment } from "react";
import "./footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Fragment>
      <div className="container-fluid footer_body">
        <div className="container main_footer">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 footer_logo_body">
              <img src="https://s18.picofile.com/file/8439946200/loho_aroosaki.png" />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
              <ul className="footer_ul_body">
                <Link style={{ textDecoration: "none" }} to="/about">
                  <li className="footer_menu_item">درباره ما</li>
                </Link>
                <Link style={{ textDecoration: "none" }} to="/contact">
                  <li className="footer_menu_item">تماس با ما</li>
                </Link>
                <Link style={{ textDecoration: "none" }} to="/">
                  <li className="footer_menu_item">صفحه اصلی</li>
                </Link>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 footer_icons">
              <i className="uil uil-twitter"></i>
              <i className="uil uil-facebook"></i>
              <i className="uil uil-instagram"></i>
              <i className="uil uil-whatsapp"></i>
              <i className="uil uil-youtube"></i>
            </div>
          </div>
          <hr style={{ background: "white" }} />
          <div className="row">
            {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 copyright_body">
              طراحی با
              <i className="uil uil-heart"></i>
              توسط احمد احمدنژاد
            </div> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
